import { createRoute } from '@tanstack/react-router';
import { RezervacePage } from '@/modules/pujcovna/RezervacePage';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/rezervace',
  component: RezervacePage,
});
